import { Typography } from "@mui/material";
import { FooterContainer } from "./styles";

const Footer = () => {
  return (
    <FooterContainer>
      <p>© 2022 - Torneio Fácil</p>
      <Typography sx={{ fontFamily: 'inter, sans-serif' }}>
        {process.env.REACT_APP_PROJECT_VERSION}
      </Typography>
    </FooterContainer>
  );
};

export default Footer;
